import { key } from 'core-ts-types';
import { ICourse, IPlannedCourse, ITermCourse } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
export class TermPlannedCourse implements IPlannedCourse {
  static build(plannedCourse: IPlannedCourse) {
    return new TermPlannedCourse(plannedCourse);
  }
  id: number;
  term: number;
  program_slot: number; // Its would be a number but in context of Scheduler this is always null. No dev-req are shown on scheduler.
  course: number;
  is_prereq_satisfied: boolean;
  is_coreq_satisfied: boolean;
  prereq_miss: number[];
  prereq_outoforder: number[];
  coreq_miss: number[];
  coreq_outoforder: number[];
  status: string | null;
  is_locked: boolean;

  constructor(plannedCourse: IPlannedCourse) {
    _4.merge(this, plannedCourse);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/builders/term_planned_course_builder.ts